/**
 * Converts a camelCase or PascalCase string to Title Case.
 *
 * @param {string} text - The input string to convert.
 * @returns {string} - The converted Title Case string.
 */
export function convertToTitleCase(text) {
  if (!text || typeof text !== "string") return "";

  // Match sequences of lowercase letters followed by uppercase letters
  const words = text.match(/([A-Z]?[a-z]+|[A-Z]+)/g);
  if (!words) return text;

  // Capitalize each word
  const titleCase = words.map(
    (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  );

  // Join the words with spaces
  return titleCase.join(" ");
}

export function getMonthName(monthNumber) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return months[monthNumber-1]; // Subtract 1 since array is 0-based
}

/**
 * Recursively removes keys with empty string (""), null, or undefined values from an object.
 *
 * @param {object} obj - The input object to clean.
 * @returns {object} - The cleaned object without empty keys.
 */
export function removeEmptyKeys(obj) {
  if (obj === null || typeof obj !== "object" || Array.isArray(obj)) {
    return obj;
  }
  const cleaned = {};
  for (const [key, value] of Object.entries(obj)) {
    if (value === "" || value === null || value === undefined) {
      continue;
    }
    if (typeof value === "object" && !Array.isArray(value)) {
      cleaned[key] = removeEmptyKeys(value);
    } else {
      cleaned[key] = value;
    }
  }
  return cleaned;
}
